// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Effect_Exception from "../Effect.Exception/index.js";
import * as Effect_Uncurried from "../Effect.Uncurried/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Foreign from "../Foreign/index.js";
var composeKleisliFlipped = /* #__PURE__ */ Control_Bind.composeKleisliFlipped(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var parseJSON = /* #__PURE__ */ (function () {
    var $5 = Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)((function () {
        var $8 = Control_Applicative.pure(Data_List_Types.applicativeNonEmptyList);
        return function ($9) {
            return $8(Foreign.ForeignError.create(Effect_Exception.message($9)));
        };
    })());
    var $6 = Effect_Uncurried.runEffectFn1($foreign.parseJSONImpl);
    return function ($7) {
        return Control_Monad_Except_Trans.ExceptT(Data_Identity.Identity($5(Effect_Unsafe.unsafePerformEffect(Effect_Exception["try"]($6($7))))));
    };
})();
var decodeJSONWith = function (f) {
    return composeKleisliFlipped(f)(parseJSON);
};
export {
    parseJSON,
    decodeJSONWith
};
